import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Lock, MapPin } from "lucide-react";

export default function FeedPage() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/posts").then((r) => setPosts(r.data || []));
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 md:px-8 py-12" data-testid="feed-page">
      <div className="overline">Feed</div>
      <h1 className="font-display text-5xl md:text-6xl uppercase mt-3">Field notes</h1>
      <p className="text-white/70 mt-4 max-w-2xl">
        Stories, photos, and audio dispatches pinned to where they happened. Locked posts open as
        the Sentra rolls in.
      </p>

      <div className="mt-10 space-y-8">
        {posts.map((p, i) => (
          <article
            key={p.id}
            className="tac-card overflow-hidden grid md:grid-cols-12"
            data-testid={`feed-post-${p.id}`}
          >
            <div className="md:col-span-5">
              {p.unlocked && p.image_url ? (
                <div
                  className="aspect-[4/3] md:aspect-auto md:h-full bg-cover bg-center"
                  style={{ backgroundImage: `url(${p.image_url})` }}
                />
              ) : (
                <div className="aspect-[4/3] md:aspect-auto md:h-full bg-[#141414] flex items-center justify-center">
                  <Lock size={36} className="text-[#FF1493]" />
                </div>
              )}
            </div>
            <div className="md:col-span-7 p-7">
              <div className="flex items-center gap-3 mb-3">
                <span className="overline">#{String(i + 1).padStart(3, "0")}</span>
                <span className="font-mono-tactical text-xs text-white/60 flex items-center gap-1">
                  <MapPin size={12} /> {p.location_label}
                </span>
                {!p.unlocked && (
                  <span className="font-mono-tactical text-xs text-[#FF1493] uppercase">
                    Locked
                  </span>
                )}
              </div>
              <h2 className="font-display text-3xl md:text-4xl uppercase">{p.title}</h2>
              <p className="text-white/75 mt-4 leading-relaxed">
                {p.unlocked
                  ? p.body
                  : `This dispatch unlocks once the Sentra rolls into ${p.location_label}. Bookmark it.`}
              </p>
            </div>
          </article>
        ))}
        {posts.length === 0 && (
          <div className="text-white/60 text-center py-20">No posts yet. Check back when the engine starts.</div>
        )}
      </div>
    </div>
  );
}
